import { render, staticRenderFns } from "./DialogoAccionAcceso.vue?vue&type=template&id=01511cd7&scoped=true"
import script from "./DialogoAccionAcceso.vue?vue&type=script&lang=js"
export * from "./DialogoAccionAcceso.vue?vue&type=script&lang=js"
import style0 from "./DialogoAccionAcceso.vue?vue&type=style&index=0&id=01511cd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01511cd7",
  null
  
)

export default component.exports